<template>
    <div class="model">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>权限管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>模块管理</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-tree
                    :load="load"
                    ref="tree"
                    lazy
                    node-key="id"
                    :props="props"
                    :expand-on-click-node="false"
                    accordion>
                    <div class="custom-tree-node" slot-scope="{ node, data }">
                        <span style="flex-grow: 1">
                            <el-popover
                                placement="top-start"
                                width="200"
                                trigger="hover"
                                :content="node.data.description">
                                <span slot="reference"><i v-if="node.data.fid == 'root'" :class="node.data.icon"></i>{{ node.label }}</span>
                            </el-popover>
                        </span>
                        <span style="width: 100px; text-align: center; margin-right: 50px;">{{ typeFormatter(node.data.type) }}</span>
                        <span style="width: 460px">{{ node.data.uri }}</span>
                        <span style="width: 80px; text-align: center">
                            <el-tag
                                :type="node.data.status ===  1 ? 'primary' : 'info'"
                                disable-transitions>{{node.data.status === 1 ? "有效" : "无效" }}</el-tag>
                        </span>
                        <span style="margin-right: 30px;text-align:right; width: 280px">
                            <el-button :disabled="node.data.type != 0 && node.data.type != 1"
                                type="text"
                                size="mini"
                                       @click="handleAdd(node)">添加子模块</el-button>
                            <el-divider direction="vertical" ></el-divider>
                            <el-button :disabled="node.data.id === 'root'"
                                size="mini"  type="text"
                                @click="handleEdit(node)">编辑信息</el-button>
                            <el-divider direction="vertical" ></el-divider>
                            <el-button :disabled="node.data.id === 'root'"
                                size="mini"
                                type="text"
                                @click="handleDelete(node)">删除</el-button>
                        </span>
                    </div>
                </el-tree>
            </el-card>
        </main>
        <el-dialog title="模块信息" :visible.sync="editDialogVisible" width="500px" :close-on-click-modal="false">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="80px">
                <el-form-item label="图标">
                    <el-select v-model="editForm.icon" placeholder="请选择" clearable>
                        <el-option value="el-icon-delete-solid"><i class="el-icon-delete-solid"></i></el-option>
                        <el-option value="el-icon-s-shop"><i class="el-icon-s-shop"></i></el-option>
                        <el-option value="el-icon-setting"><i class="el-icon-setting"></i></el-option>
                        <el-option value="el-icon-key"><i class="el-icon-key"></i></el-option>
                        <el-option value="el-icon-document-copy"><i class="el-icon-document-copy"></i></el-option>
                        <el-option value="el-icon-user"><i class="el-icon-user"></i></el-option>
                        <el-option value="el-icon-notebook-1"><i class="el-icon-notebook-1"></i></el-option>
                        <el-option value="el-icon-s-data"><i class="el-icon-s-data"></i></el-option>
                        <el-option value="el-icon-data-analysis"><i class="el-icon-data-analysis"></i></el-option>
                        <el-option value="el-icon-shopping-cart-full"><i class="el-icon-shopping-cart-full"></i></el-option>
                        <el-option value="el-icon-notebook-2"><i class="el-icon-notebook-2"></i></el-option>
                    </el-select>
                    <!-- <el-input v-model="editForm.icon" placeholder="请输入图标类名" clearable></el-input> -->
                </el-form-item>
                <el-form-item label="名称" prop="name">
                    <el-input v-model="editForm.name" placeholder="请输入名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="类型" prop="type">
                    <el-select v-model="editForm.type" placeholder="请选择类型" clearable>
                        <el-option label="菜单" value="0"></el-option>
                        <el-option label="功能" value="1"></el-option>
                        <el-option label="接口" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input v-model="editForm.description" placeholder="请输入描述" clearable></el-input>
                </el-form-item>
                <el-form-item label="URI">
                    <el-input v-model="editForm.uri" placeholder="请输入URI" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-select v-model="editForm.status" placeholder="请选择状态" clearable>
                        <el-option label="无效" value="0"></el-option>
                        <el-option label="有效" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input v-model="editForm.sort" placeholder="请输入排序号" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>

export default {
    data() {
        return {
            loading: false,
            props: {
                id: "id",
                label: 'name',
                children: 'children',
                isLeaf: 'leaf'
            },
            tableData: [
                {
                    id: "root",
                    fid: "",
                    name: "功能列表",
                    type: 0,
                    description: "-",
                    uri: "-",
                    status: 1,
                    children: [],
                    hasChildren: true
                }
            ],
            editForm: {
                id: "",
                icon: "",
                fid: "",
                name: "",
                type: "0",
                description: "",
                uri: "",
                status: "1",
                sort: 0,
            },
            currentNode: {},
            editDialogVisible: false,
            treeInfo: [],
            rules: {
                name: [
                    { required: true, message: '请输入名称', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: '请选择类型', trigger: 'blur' }
                ],
                status: [
                    { required: true, message: '请选择状态', trigger: 'blur' }
                ],
            },
        }
    },
    methods: {
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        load(node, resolve) {
            if(node.level === 0) {
                resolve([{id: "root", name: "功能一览", type: 0, description: "功能一览", uri: "-", status: 1}])
            } else {
                this.loading = true;
                let _this = this;
                this.$axios.post("/admin/rights/model/list", {
                    fid: node.data.id,
                }).then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        resolve(resp.data.map(it => ({...it, leaf: (it.children || []).length === 0})));
                    } else {
                        _this.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                    _this.loading = false;
                }).catch(function() {
                    _this.loading = false;
                });
            }
        },
        typeFormatter(data) {
            switch(data) {
                case 0:
                    return "菜单";
                case 1:
                    return "模块";
                case 2:
                    return "接口";
                default:
                    return "数据错误";
            }
        },
        handleAdd(node) {
            let data = node.data;
            this.editForm = {
                id: "",
                icon: "",
                fid: data.id,
                name: "",
                type: "0",
                description: "",
                uri: "",
                status: "1",
                sort: 0,
            }
            this.currentNode = node;
            this.editDialogVisible = true;
        },
        handleEdit(node) {
            let data = node.data;
            if(data.id == "root") {
                this.$notify({
                    title: '提示',
                    message: '这条不能修改',
                    type: 'warning'
                });
                return;
            }
            this.editForm = {
                id: data.id,
                icon: data.icon,
                fid: data.fid,
                name: data.name,
                type: data.type + "",
                description: data.description,
                uri: data.uri,
                status: data.status + "",
                sort: data.sort,
            }
            this.currentNode = node;
            this.editDialogVisible = true;
        },
        handleDelete(node) {
            let _this = this;
            if(node.data.id == "root") {
                this.$notify({
                    title: '提示',
                    message: '这条不能删除',
                    type: 'warning'
                });
                return;
            }
            this.$confirm('是否删除模块【' + node.data.name + '】？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消'
            }).then(() => {
                _this.$axios.get("/admin/rights/model/delete/" + node.data.id)
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status === 0) {
                        _this.$notify({
                            title: '成功',
                            message: '数据删除成功',
                            type: 'success'
                        });
                        _this.$refs.tree.remove(node);
                    } else {
                        _this.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
            })
        },
        onSubmit() {
            let that = this;
            this.$refs.editForm.validate(valid => {
                if (valid) {
                    this.$axios.post("/admin/rights/model", this.editForm)
                    .then(function(response) {
                        let resp = response.data;
                        if(resp.header.status == 0) {
                            if(that.editForm.id == "") {
                                const parentNode = that.$refs.tree.getNode(resp.data.fid);
                                that.$refs.tree.append(resp.data, parentNode);
                                that.$notify({
                                    title: '成功',
                                    message: '数据添加成功',
                                    type: 'success'
                                });
                            } else {
                                that.$notify({
                                    title: '成功',
                                    message: '数据修改成功',
                                    type: 'success'
                                });
                                let node = that.$refs.tree.getNode(resp.data.id);
                                node.data = resp.data;
                            }
                            that.editDialogVisible = false;
                        }
                    })
                }
            });
        },
    },
    created() {
    },
}
</script>
<style>
.custom-tree-node {
    display: flex;
    width: 100%;
    height: 48px;
    line-height: 48px;
}
.el-tree-node__content {
    height: 48px !important;
}
</style>
